export default __webpack_public_path__ + "static/media/light_normal_light.b53de8dd.svg";